// PERSONAL LIBS
import { logger } from '@shared/lib/logger/logger-manager'
import { RepositoryStrategyEnum } from '@shared/enum/repository-strategy.enum'
import { UpdateManagerUi } from '@shared/service/updateManager/update-manager-ui.service'
import { IChangelog } from '@shared/interface/model.interface'

class CheckAppVersion {
  private localVersion: string | undefined
  private remoteVersion: Promise<IChangelog | undefined>

  constructor() {
    this.localVersion = undefined
    this.remoteVersion = Promise.resolve(undefined)
  }

  init() {
    this.localVersion = process.env.FRONTEND.currentVersion
    this.remoteVersion = new UpdateManagerUi.UiChangelog()
      .setCanRunInParallel(true)
      .exec<IChangelog>(RepositoryStrategyEnum.NETWORK_FIRST)
  }

  /**
   *
   * Detect if it is needed to refresh the app (version deviation between current version and remote version)
   *
   * @return {Promise<boolean>}
   */
  async hasToBeRefreshed(): Promise<boolean> {
    const remoteVersion = (await this.remoteVersion)?.version?.frontend
    logger?.log(`this.localVersion : ${this.localVersion ?? 'null'}`)
    logger?.log(`this.remoteVersion : ${remoteVersion ?? 'null'}`)
    logger?.log(`hasToBeRefreshed : ${String(this.localVersion !== remoteVersion)}`)
    return remoteVersion != null && this.localVersion !== remoteVersion
  }

  async getRemoteVersion(): Promise<string | undefined> {
    return (await this.remoteVersion)?.version?.frontend
  }

  getLocalVersion(): string | undefined {
    return this.localVersion
  }
}

export default CheckAppVersion
